// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__K-OTx","text":"styles_text__UvYzr","arrow":"styles_arrow__fciYl"};